import type { ReactElement } from 'react';

import Layout from '@/components/Landing/Layout';
import ClientPage from '@/components/OurSuccessStories/ClientPage';
import Text from '@/components/Text';

const PegasusSolar = () => {
  return (
    <ClientPage
      companyName="Pegasus Solar"
      clientId="pegasus"
      description={
        <>
          <Text variant="body" className="text-jb-neutral-100">
            The MindPal Team created a{' '}
            <strong>comprehensive software solution</strong> that optimized the
            efficiency and management of the company’s solar power
            infrastructure.
          </Text>
          <Text variant="body" className="text-jb-neutral-100">
            The platform provided <strong>real-time system monitoring</strong>,
            predictive maintenance algorithms, and a user-friendly interface
            that allowed{' '}
            <strong>seamless control, data visualization, and reporting</strong>
            .
          </Text>
        </>
      }
      topImage="/clients/pegasus-solar/roof-project.mp4"
      bottomImage="/clients/pegasus-solar/glide.mp4"
      scope={
        <>
          <Text variant="body" className="text-jb-neutral-400">
            Complete design and development of a software solution for
            monitoring and optimizing the company’s solar power infrastructure.
          </Text>
          <Text variant="body" className="text-jb-neutral-400">
            The scope included{' '}
            <strong>
              system architecture, UI/UX design, integration of predictive
              maintenance algorithms
            </strong>
            , and implementation of{' '}
            <strong>real-time data visualization</strong> and{' '}
            <strong>reporting tools.</strong>
          </Text>
        </>
      }
      industry="Solar Technology"
      country="Richmond, CA, USA"
    />
  );
};

PegasusSolar.getLayout = (page: ReactElement) => (
  <Layout theme="dark">{page}</Layout>
);

export default PegasusSolar;
